import { Component, OnInit, OnDestroy } from '@angular/core';
import { io, Socket } from 'socket.io-client';

@Component({
  selector: 'app-websocket-test',
  template: `
    <div class="p-4">
      <h2 class="text-xl font-bold mb-4">WebSocket Test</h2>
      
      <div class="mb-4">
        <button 
          (click)="sendMessage()" 
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          [disabled]="!isConnected">
          Send "Hi" Message
        </button>
      </div>
      
      <div class="mb-4">
        <p><strong>Connection Status:</strong> 
          <span [class]="isConnected ? 'text-green-600' : 'text-red-600'">
            {{ isConnected ? 'Connected' : 'Disconnected' }}
          </span>
        </p>
      </div>
      
      <div class="mb-4">
        <h3 class="font-semibold mb-2">Messages:</h3>
        <div class="border p-2 rounded bg-gray-50 min-h-[100px]">
          <div *ngFor="let msg of messages" class="mb-1">
            <span class="text-sm text-gray-600">{{ formatTime(msg.timestamp) }}:</span>
            <span [class]="msg.type === 'sent' ? 'text-blue-600' : 'text-green-600'">
              {{ msg.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class WebsocketTestComponent implements OnInit, OnDestroy {
  private socket: Socket;
  isConnected = false;
  messages: Array<{text: string, type: 'sent' | 'received', timestamp: Date}> = [];

  constructor() {
    // Initialize socket connection to backend
    this.socket = io('http://localhost:3500');
  }

  ngOnInit() {
    this.setupSocketListeners();
  }

  ngOnDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  private setupSocketListeners() {
    // Connection event
    this.socket.on('connect', () => {
      console.log('Connected to WebSocket server');
      this.isConnected = true;
      this.addMessage('Connected to server', 'received');
    });

    // Disconnection event
    this.socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket server');
      this.isConnected = false;
      this.addMessage('Disconnected from server', 'received');
    });

    // Message event
    this.socket.on('message', (data: string) => {
      console.log('Received message:', data);
      this.addMessage(data, 'received');
    });
  }

  sendMessage() {
    if (this.isConnected) {
      const message = 'Hi';
      this.socket.emit('message', message);
      this.addMessage(message, 'sent');
      console.log('Sent message:', message);
    }
  }

  private addMessage(text: string, type: 'sent' | 'received') {
    this.messages.push({
      text,
      type,
      timestamp: new Date()
    });
  }

  formatTime(date: Date): string {
    return date.toLocaleTimeString('en-US', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit' 
    });
  }
}
